module.exports = __webpack_public_path__ + "static/media/external-small_minor.ed58bd0f.svg";